
  import { mapState } from 'vuex'
  export default {
    data() {
      return {
        paymentType: '',
        forceToAddBankAccountModal: false,
        disabledToDeposit: false,
        disabledBank: true,
        disabledThirdParty: true,
        disabledCrypto: true
      }
    },
    computed: {
      ...mapState({
        player: state => state.player.player,
        depositFlow: state => state.themes.deposit.depositFlow,
        checkExist: state => state.themes.deposit.checkExist,
        checkDeposit: state => state.themes.deposit.checkDeposit
      }),
      depositType() {
        if (!this.depositFlow.deposit_type) return null
        return ~~this.depositFlow.deposit_type
      },
      showBankPayment() {
        if (this.depositType === 1) return false
        return this.depositFlow.is_bank_transfer_enabled
      },
      showOnlinePayment() {
        if (this.depositType === 1) return false
        return this.depositFlow.is_third_party_payment_enabled
      },
      showCryptoCurrency() {
        if (this.depositType === 1) return false
        return this.depositFlow.is_crypto_payment_enabled
      }
    },
    watch: {
      player(value) {
        this.checkWebsiteSettings()
      },
      depositFlow(value) {
        if (!this.paymentType) {
          if (value?.is_bank_transfer_enabled) {
            this.paymentType = 'bank'
          } else if (value?.is_third_party_payment_enabled) {
            this.paymentType = 'online'
          } else if (value?.is_crypto_payment_enabled) {
            this.paymentType = 'crypto'
          }
        }
        // execute only inter wl
        if (value?.reg_flow) {
          const hasBankAccount = this.player.has_bank_account
          if (
            hasBankAccount === false &&
            ~~value?.reg_flow === 3 &&
            (value?.is_bank_transfer_enabled || value.is_third_party_payment_enabled)
          ) {
            this.forceToAddBankAccountModal = true
            this.disabledToDeposit = true
          } else {
            this.disabledToDeposit = false
            this.forceToAddBankAccountModal = false
          }
        }
        if (~~value?.reg_flow === 5) {
          this.paymentType = 'crypto'
        }
      },
      checkExist(value) {
        if (value?.is_exist) {
          this.enableDisabledPaymentMethod(value)
        }
      },
      checkDeposit(value) {
        if (value) {
          this.disabledBank = true
          this.disabledThirdParty = true
          this.disabledCrypto = true
        }
      }
    },
    mounted() {
      this.checkWebsiteSettings()
      this.isExit()
      // execute only lao wl
      // if (!this.isInternational)
      //   this.$store.dispatch('themes/deposit/depositFlow', this.$cookie.get('player')?.currency)
      // execute only inter w
      this.$store.dispatch('settings/operationSetting', this.$cookie.get('player')?.currency)

      // unsubscribe vuex mutation
      this.subscribeAction = this.$store.subscribeAction((mutation, state) => {
        if (
          mutation.type === 'sockets/revokeDepositByAdmin' ||
          mutation.type === 'sockets/confirmDepositByAdmin' ||
          mutation.type === 'sockets/successfulDeposit'
        ) {
          this.isExit()
        }
      })
    },
    beforeDestroy() {
      // unsubscribe the store action
      if (this.subscribeAction) {
        this.subscribeAction()
      }
    },
    methods: {
      checkWebsiteSettings() {
        const hasBankAccount = this.player.has_bank_account
        const registrationType = this.player.registration_type

        if (
          hasBankAccount === false &&
          registrationType === 3 &&
          (this.depositFlow?.is_bank_transfer_enabled ||
            this.depositFlow?.is_third_party_payment_enabled)
        ) {
          this.forceToAddBankAccountModal = true
          this.disabledToDeposit = true
        }
      },
      async isExit() {
        const isExist = await this.$store.dispatch('themes/deposit/checkExist')
        this.enableDisabledPaymentMethod(isExist)
      },
      enableDisabledPaymentMethod(data) {
        if (data && data.is_exist === true && data.payment_provider_code === 'manual_transfer') {
          this.paymentType = 'bank'
          this.disabledBank = false
          this.disabledThirdParty = true
          this.disabledCrypto = true
        } else if (data && data.is_exist === true && data.payment_provider_code === 'crypto') {
          this.paymentType = 'crypto'
          this.disabledBank = true
          this.disabledThirdParty = true
          this.disabledCrypto = false
        } else if (data && data.is_exist === true && data.payment_provider_code === 'third_party') {
          this.paymentType = 'online'
          this.disabledBank = true
          this.disabledThirdParty = false
          this.disabledCrypto = true
        } else {
          this.disabledBank = false
          this.disabledThirdParty = false
          this.disabledCrypto = false
        }
      },
      onClickBannerDeposit(link) {
        if (!link) return null
        window.open(this.fixUrlProtocol(link), '_blank')
      },
      fixUrlProtocol(url) {
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = 'https://' + url
        }
        return url
      }
    }
  }
